import Icon from '@mui/icons-material/Info';
import { SvgIconPropsOverrides } from '../../../model/icon';

export default function InfoIcon({ className = '', ...props }: SvgIconPropsOverrides) {
	return <Icon className={`${className}`} {...props} />;
}
